import { Injectable } from "@angular/core";
import { CategoryGroup } from './ceo-desk.model';

@Injectable({
    providedIn: "root",
})
export class CeoDeskService {

   private  categoryGroup: CategoryGroup;


   setCategoryGroup(categoryGroup: CategoryGroup){
    this.categoryGroup = categoryGroup;
   }

   getCategoryGroup(): CategoryGroup{
       return  this.categoryGroup;
   }

}
